import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import {
  Button,
  Container,
  Row,
  Col,
  Nav,
  Navbar,
  Card,
  Badge,
  FormGroup,
} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import ProfileEdit from "../../../src/assets/images/profile-edit.svg";
import { getUserDetails } from "../../services/userService";
import storage from "../../helpers/storage";
import Modal from "react-bootstrap/Modal";
import { Formik } from "formik";
import InputText from "../../components/common/InputText";
import InputPassword from "../../components/common/InputPassword";
import TextField from "@mui/material/TextField";
import { changePassword, changeSignature } from "../../services/userService";
import { ChangePasswordSchema, SignatureSchema } from "../../validations/Users";
import Loader from "../../components/common/Loader";
import SignatureCanvas from "react-signature-canvas";
import phoneMask from "../../helpers/phoneMask";
import styles from "./styles.module.css";
import { generateSerialNumber } from "../../helpers/common";
import { nameBasedRoutes } from "../../router/public";
import { nameBasedProtectedRoutes } from "../../router/protected";
import { toast } from "react-toastify";
import { MESSAGES } from "../../constants/messages";

export const Profile = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [userData, setuserData] = useState<any>({
    id: "",
    first_name: "",
    last_name: "",
    email: "",
    createdAt: "",
    updatedAt: "",
    role: "",
    company_name: "",
    phone_no: null,
    cell_no: null,
    fax_no: null,
    status: "",
    address: "",
    state_id: "",
    city: "",
    zipcode: 0,
    signature: 0,
    billingContact: {
      name: "",
      email: "",
      cell_number: "",
      address: "",
      state_id: null,
      city: "",
      zip_code: "",
      state: {
        title: "",
        code: "",
      },
    },
    decalContact: {
      name: null,
      email: "",
      cell_number: "",
      address: "",
      state_id: null,
      city: "",
      zip_code: "",
      state: {
        title: "",
        code: "",
      },
    },
    yardAddress: {
      address: "",
      state_id: null,
      city: "",
      zip_code: "",
      state: {
        title: "",
        code: "",
      },
    },
    state: {
      title: "",
      code: "",
    },
  });
  const userInformation: any = storage.getData("user-info");
  const userId = userInformation.id;
  const [show, setShow] = useState(false);
  const handleModalClose = () => setShow(false);
  const handleShow = () => setShow(true);

  let sigCanvas = useRef<any>({});
  const [showSign, setShowSign] = useState(false);

  const handleSignShow = () => setShowSign(true);
  let [data, setData] = useState("");

  const initialValues = {
    currentPassword: "",
    password: "",
    confirmPassword: "",
  };

  const initialValuesSign = {
    sign: "",
    witness: "",
  };

  useEffect(() => {
    if (storage.getToken() != null) {
      getUserData();
    }
  }, []);

  const getUserData = async () => {
    setLoading(true);
    getUserDetails({ userId })
      .then((response) => {
        setLoading(false);
        setuserData(response?.data);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  /**
   * Submit Method to call when user clicks on login button
   * @async
   * @param {string} currentPassword
   * @param {string} password
   * @param {string} confirmPassword
   * @returns {*}
   */
  const submitForm = async (currentPassword: string, password: string) => {
    setLoading(true);
    changePassword({ userId, currentPassword, password })
      .then((response) => {
        setLoading(false);
        toast.success(MESSAGES.passwordChanged);

        handleModalClose();
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  const submitSignatureForm2 = async (sign: string) => {};
  let signature = "";
  const submitSignatureForm = async () => {
    setLoading(true);
    signature = data;
    changeSignature({ userId, signature })
      .then((response) => {
        // setLoading(false);
        getUserData();
        toast.success(MESSAGES.signatureUploaded);
        handleSignModalClose();
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  function setSignatureOnChange() {
    setData(sigCanvas?.current?.toDataURL("image/png"));
  }

  const handleSignModalClose = () => {
    sigCanvas?.current?.clear();
    setShowSign(false);
    setData("");
  };

  return (
    <>
      <section className="profile-main pt-4 dashboard-content">
        <Container className="">
          <Row>
            <Col md={6} lg={6}>
              <Breadcrumb className="border-0 shadow-none mb-0">
                <Breadcrumb.Item
                  className="fs-15 fw-semibold text-link"
                  href="Javascript:void(0)"
                  onClick={() =>
                    navigate(nameBasedProtectedRoutes.dashborad.path)
                  }
                >
                  Dashboard
                </Breadcrumb.Item>

                <Breadcrumb.Item active className="fs-15 fw-semibold text-gray">
                  My Profile
                </Breadcrumb.Item>
              </Breadcrumb>
              <h1 className="fs-30 fw-bold mb-3 mt-2">My Profile</h1>
            </Col>
            <Col
              md={6}
              lg={6}
              className="align-items-start col-lg-6 col-md-6 d-flex justify-content-md-end mb-lg-0 mb-3"
            >
              <Button
                className="fs-15 fw-semibold text-black"
                variant="primary"
                onClick={handleShow}
              >
                Change Password
              </Button>
            </Col>
          </Row>
          <Form>
            <Row>
              <Col md={12} lg={12}>
                <Card className="border-0 mb-3">
                  <Card.Body className="br-10 p-4">
                    <h2 className="fs-20  ls-2 border-left-6">
                      <span className="fw-bold">MAIN CONTACT{" "}</span>
                      <Badge className="fs-15 ls-0 badge-bg text-default fw-normal">
                        Customer ID:{" "}
                        <span className="fw-bold">
                          #
                          {generateSerialNumber(
                            userData?.created_at,
                            userData?.id,
                            ""
                          )}
                        </span>
                      </Badge>
                    </h2>

                    <Row className="mt-3">
                      <Col md={8} lg={9}>
                        <Row>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                First Name
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.first_name}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Last Name
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.last_name}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Email
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.email}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Company Name
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.company_name}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Phone
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {phoneMask(userData?.phone_no)}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Cell Phone
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {phoneMask(userData?.cell_no)}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Fax No
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.fax_no
                                  ? phoneMask(userData?.fax_no)
                                  : "-"}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Address
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.address}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                City
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.city}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                State
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.state_id ? userData?.state?.title : ""}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Zip
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.zipcode}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Yard Address
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.yardAddress?.address}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                City
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.yardAddress?.city}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                State
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.yardAddress?.state?.title}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Zip
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.yardAddress?.zip_code}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={4} lg={3}>
                        <Card className="card-bg card-border">
                          <Card.Body>
                            <Card.Title className="fs-16 fw-bold text-default">
                              MY SIGNATURE{" "}
                              <span
                                className="float-end"
                                style={{ cursor: "pointer" }}
                                onClick={handleSignShow}
                              >
                                <img src={ProfileEdit} />
                              </span>
                            </Card.Title>

                            <label className="w-100">
                              <Form.Group className="profile-browse-box">
                                {userData?.signature ? (
                                  <img
                                    className={styles.sigImage}
                                    src={userData?.signature}
                                  />
                                ) : (
                                  <div>No Signature</div>
                                )}
                                {/*<Form.Control type="file" style={{opacity:0}}/>*/}
                              </Form.Group>
                            </label>

                            <Card.Text className="fs-15 text-default">
                              Click for update your signature
                            </Card.Text>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
                <Card className="border-0 mb-3">
                  <Card.Body className="br-10 p-4">
                    <h2 className="fs-20 fw-bold ls-2 border-left-6">
                      BILLING CONTACT
                    </h2>

                    <Row className="mt-3">
                      <Col md={12} lg={12}>
                        <Row>
                          <Col md={3} lg={3}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Name
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.billingContact?.name}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={3} lg={3}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Cell Phone
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {phoneMask(userData?.billingContact?.cell_number)}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={3} lg={3}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Email
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.billingContact?.email}
                              </Form.Text>
                            </Form.Group>
                          </Col>

                          <Col md={3} lg={3}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Address
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.billingContact?.address}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={3} lg={3}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                City
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.billingContact?.city}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={3} lg={3}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                State
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.billingContact?.state.title}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={3} lg={3}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Zip
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.billingContact?.zip_code}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
                <Card className="border-0 mb-3">
                  <Card.Body className="br-10 p-4">
                    <h2 className="fs-20 fw-bold ls-2 border-left-6">
                      DECAL CONTACT
                    </h2>

                    <Row className="mt-3">
                      <Col md={12} lg={12}>
                        <Row>
                          <Col md={3} lg={3}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Name
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.decalContact?.name}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={3} lg={3}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Cell Phone
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {phoneMask(userData?.decalContact?.cell_number)}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={3} lg={3}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Email
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.decalContact?.email}
                              </Form.Text>
                            </Form.Group>
                          </Col>

                          <Col md={3} lg={3}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Address
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.decalContact?.address}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={3} lg={3}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                City
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.decalContact?.city}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={3} lg={3}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                State
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.decalContact?.state?.title}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={3} lg={3}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Zip
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userData?.decalContact?.zip_code}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Form>
        </Container>
      </section>

      <Modal
        show={show}
        onHide={handleModalClose}
        centered
        dialogClassName="modal-350w"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fs-25 fw-bold">Change password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validationSchema={ChangePasswordSchema}
            initialValues={initialValues}
            onSubmit={(values, actions) => {
              actions.setSubmitting(false);
              submitForm(values.currentPassword, values.password);
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
            }) => (
              <Form className="text-start" noValidate onSubmit={handleSubmit}>
                {/* <TextField
                                id="outlined-password-input"
                                label="Current Password"
                                type="Current Password"
                                autoComplete="current-password"/>

                                <TextField
                                id="outlined-password-input"
                                label="New password"
                                type="New password"
                                autoComplete="current-password"/>

                                <TextField
                                id="outlined-password-input"
                                label="Confirm new password"
                                type="Confirm new password"
                                autoComplete="current-password"/>*/}
                <InputPassword
                  controlId="currentPassword"
                  label="Current Password"
                  placeholder="Enter Current Password"
                  handleBlur={handleBlur}
                  touched={touched.currentPassword}
                  handleChange={handleChange}
                  errorsField={errors.currentPassword}
                  value={values.currentPassword}
                />
                <InputPassword
                  controlId="password"
                  label="New Password"
                  placeholder="Enter Password"
                  touched={touched.password}
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  errorsField={errors.password}
                  value={values.password}
                />
                <InputPassword
                  controlId="confirmPassword"
                  label="Confirm Password"
                  placeholder="Enter Password"
                  handleBlur={handleBlur}
                  touched={touched.confirmPassword}
                  handleChange={handleChange}
                  errorsField={errors.confirmPassword}
                  value={values.confirmPassword}
                />


                <div className="d-flex justify-content-end">
                  <Button
                    variant="outline-secondary"
                    className="me-2 fs-15 fw-semibold"
                    onClick={handleModalClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    className="fs-15 fw-semibold text-black"
                    type="submit"
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>

      {/*Signature Modal*/}
      <Modal
        show={showSign}
        onHide={handleSignModalClose}
        centered
        dialogClassName="modal-400w"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fs-25 fw-bold">My Signature</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validationSchema={SignatureSchema}
            initialValues={initialValuesSign}
            onSubmit={(values, actions) => {
              actions.setSubmitting(false);
              submitSignatureForm2(values.sign);
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
            }) => (
              <Form className="text-start" noValidate onSubmit={handleSubmit}>
                <div className={styles.sigContainer}>
                  <SignatureCanvas
                    ref={sigCanvas}
                    penColor="black"
                    canvasProps={{ className: styles.sigPad }}
                    onEnd={setSignatureOnChange}
                  />
                  <p>
                    Sign here using MOUSE or TOUCH screen if using a tablet.
                  </p>
                </div>
                <div className="d-flex justify-content-end mt-4">
                  <Button
                    variant="outline-secondary"
                    className="me-2 fs-15 fw-semibold "
                    onClick={handleSignModalClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    className="fs-15 fw-semibold text-black"
                    type="button"
                    onClick={submitSignatureForm}
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>

      <Loader isLoading={loading} />
    </>
  );
};
